import React, { useState } from 'react';
import { OperatingSystemOption } from '../../../types/vm.type';

interface OSCardProps {
  os: OperatingSystemOption;
  isSelected: boolean;
  onSelect: () => void;
}

const OSCard: React.FC<OSCardProps> = ({ os, isSelected, onSelect }) => {
  const [imageError, setImageError] = useState(false);

  return (
    <button
      onClick={onSelect}
      className={`flex items-center gap-4 p-4 border-2 rounded-lg transition-all text-left ${
        isSelected
          ? 'border-black dark:border-white bg-gray-50 dark:bg-gray-700'
          : 'border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500'
      }`}
    >
      {os.isImage && !imageError ? (
        <img
          src={os.icon}
          alt={os.name}
          className="w-12 h-12 object-contain flex-shrink-0"
          onError={() => setImageError(true)}
        />
      ) : (
        <div className="text-3xl flex-shrink-0">{os.isImage ? '💻' : os.icon}</div>
      )}
      <div className="flex-1">
        <p className="font-semibold text-gray-900 dark:text-white">{os.name}</p>
        {os.description && (
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{os.description}</p>
        )}
      </div>
    </button>
  );
};

export default OSCard;
